import React, { useEffect } from 'react'

import { XMarkIcon } from '@heroicons/react/20/solid'

type KeyModalProps = {
  isModalOpen: boolean
  children: React.ReactNode
  title: string
  width?: string
  onModalClose: () => void
  parentClassName?: string
}

/**
 * @deprecated key-* components are no longer supported.
 */
const KeyModal = ({
  isModalOpen,
  title,
  children,
  onModalClose,
  width = '75%',
  parentClassName,
}: KeyModalProps) => {
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden'
    }
  }, [isModalOpen])

  const handleClose = () => {
    document.body.style.overflow = 'scroll'
    onModalClose()
  }

  const classes = parentClassName ? parentClassName : 'p-4 overflow-y-auto'

  return (
    isModalOpen && (
      <>
        <div
          id='overlay'
          className='top-0 left-0 fixed w-screen h-screen z-40 bg-gray-400/60 flex items-center justify-center'
          onClick={handleClose}
        ></div>
        <div
          className={`fixed -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 z-40 bg-white mb-4 mr-16 rounded-lg`}
          style={{ width: width }}
        >
          <div className='flex justify-between px-6 py-4 bg-sky-200 rounded-tl-lg rounded-tr-lg'>
            <h1 className='text-base'>{title}</h1>
            <XMarkIcon
              className='cursor-pointer'
              width={20}
              onClick={handleClose}
            />
          </div>
          <div className={classes}>{children}</div>
        </div>
      </>
    )
  )
}

export default KeyModal
